<template>
	<div v-if="show" class="warning-overlay gap-2 p-5">
		<h2 class="mb-3">Notice:</h2>

		<p class="mb-3 fw-bold">Orders may not execute when there is insufficient liquidity at the price specified such as sharp wicks.</p>

		<p class="mb-3 fw-bold">Limit orders work by triggering a swap when the on chain price is above/below the specified price.</p>

		<p class="mb-3 fw-bold">Increase the "Validator Tip" in <router-link to="/app/settings">Settings</router-link> to increase the priority of the Limit Order.</p>

		<p class="mb-3 fw-bold">Active orders cost 0.001 SOL in rent, when the order is complete or cancelled the rent is returned.</p>

		<div class="flex justify-content-center">
			<button @click="accepted" class="btn btn-outline-light" title="Read notice before continuing" :disabled="disabled"><i v-if="disabled" class="fa fa-spin fa-circle-notch me-1"></i>
				Accept
			</button>
		</div>
	</div>
</template>

<script>
export default {
	name: "LimitOrderWarning",
	data() {
		return {
			show: true,
			disabled: true
		}
	},
	methods: {
		accepted: function() {
			localStorage.setItem("fluxbot:lo_warning", "1")
			this.show = false
		}
	},
	beforeMount() {
		if (localStorage.getItem('fluxbot:lo_warning') === '1')
			this.show = false
	},
	mounted() {
		setTimeout(() => {
			this.disabled = false
		}, 10_000)
	}
}
</script>

<style scoped>
.warning-overlay {
	position: absolute;
	top: 0;
	left: 0;
	right: 0;
	bottom: 0;
	border: 1px solid orange;
	background: rgba(20, 20, 20, 0.95);
	z-index: 99;
}

.warning-overlay h2 {
	color: orange
}

.warning-overlay .btn:not(:disabled) {
	color: white;
	background: rgba(255, 255, 255, 0.2);
	border-color: #f8f9fa;
}
.warning-overlay .btn:hover {
	background: rgba(255, 255, 255, 0.4);
}
</style>